import { PurchasecodeGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { PurchaseCode } from "./interfaces";

export const makePurchaseCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: codes,
        allLoading: loading,
        listen,
        get,
    } = createListController<PurchasecodeGet, PurchaseCode>({
        name: "purchasecode",
        connection,
        list: (con) => con.purchasecode.items({ company: company.value }),
    });

    return { codes, loading, listen, get };
};
